import {ContextMenuContextType} from './types';

export const closeMenu = (contextMenu: ContextMenuContextType) => {
  contextMenu?.setMenuState && contextMenu.setMenuState(null);
};
